import { Matcher } from "../types";
import { evaluateJs } from "./evaluate-js";
import { locate } from "./locate";
import { navigate } from "./navigate";
import { setDevice } from "./set-device";
import { setVariation } from "./set-variation";
import { updateMods } from "./update-mods";

/**
 * Every continuation handler, each self-matching: `detectContinuation` asks each
 * one whether it handles a stream message and uses the first that does. One file
 * per tool — add a tool by adding a file and one entry here. A new continuation
 * *trigger* type (beyond ui-action output / parked client call) is just another
 * self-matching handler; detection doesn't change.
 */
export const handlers: Matcher[] = [
  navigate,
  updateMods,
  setDevice,
  setVariation,
  evaluateJs,
  locate,
];
